<ap-button (onClick)="onClick()" type="submit">
    @if (canSign()) {
        <span data-bb="enabled-sign">{{ submitText() }}</span>
    } @else {
        <span class="ap-submit" data-bb="disabled-sign">
            {{ 'loading.text' | apContent }}
            <span class="ap-submit__element ap-submit__element--first">.</span>
            <span class="ap-submit__element ap-submit__element--second">.</span>
            <span class="ap-submit__element ap-submit__element--third">.</span>
        </span>
    }
</ap-button>
